// --------------------------------------------------------
// CardAllergies - CardAllergies
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useState } from "react";
import { ContentCard } from "../../../attendanceRecord/AttendanceRecord.styled";
import { ContainerCardAllergie, IconStyled } from "./CardAllergies.styled";
import IconDelete from "../../../../../../assets/imgs/iconDelete.svg";
import GenericModal from "../../../../../../components/genericModal/GenericModal";
import { ReactComponent as Exclamation } from "../../../../../../assets/imgs/exclamationRed.svg";
import { useSelector } from "react-redux";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CardAllergies INTERFACE
// --------------------------------------------------------

interface ICardAllergies {
  data?: any;
  onClickDell: any
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardAllergies = ({ data, onClickDell }: ICardAllergies) => {
  const [showModal, setShowModal] = useState(false);
  const { currentProfile }: any = useSelector((state: any) => state.login);
  const isEnfermeiro = currentProfile === "ENF";
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)
  // --------------------------------------------------------
  // CardAllergies PRIVATE DECLARATIONS
  // --------------------------------------------------------

 

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerCardAllergie>
      <ContentCard bold>{data.tipo}</ContentCard>
      <ContentCard>{data.alergeno}</ContentCard>
      {
        !acessoProntuario ?
          <ContentCard position="end" onClick={() => setShowModal(true)}>
           <IconStyled src={IconDelete} alt="" />
          </ContentCard>
        :
          <></>
      }


      <GenericModal
        Icon={() => {
          return <Exclamation width={120} height={120} stroke={"#E7F3FD"} />;
        }}
        visible={showModal}
        onCancel={() => {
          onClickDell(data.id);
          setShowModal(false);
        }}
        onConfirm={() => {
          setShowModal(false);
        }}
        modalTitle={`Tem certeza que deseja excluir “${data.alergeno}” da lista de alergias?`}
        modalSubtitle={""}
        cancelButtonMsg={"Cancelar"}
        confirmButtonMsg={"Excluir"}
        colorButtonCancel={"#E7F3FD"}
      />
    </ContainerCardAllergie>
  );
  // --------------------------------------------------------
};

export default CardAllergies;
